class QuickViewModal extends HTMLElement {
  constructor() {
    super();
    this.body = this.querySelector('#QuickViewBody');
    this.closeTriggers = this.querySelectorAll('[data-qv-close]');
  }

  connectedCallback() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-quick-view]');
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      this.open(trigger.dataset.quickView);
    });

    this.closeTriggers.forEach((el) => el.addEventListener('click', () => this.close()));

    this.body.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-qv-thumb]');
      if (!thumb) return;
      this.swapImage(thumb);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.hasAttribute('open')) this.close();
    });

    document.addEventListener('cart:rerender', () => {
      if (this.hasAttribute('open')) this.close();
    });
  }

  open(productUrl) {
    if (!productUrl) return;
    this.setAttribute('open', '');
    this.body.innerHTML = '<div class="qv-loading">Loading…</div>';

    // Plain string concatenation broke for any URL that already has a
    // query string — recommendation-sourced product cards (cart drawer,
    // "You may also like", "Complete the Stack") get a URL like
    // /products/handle?pr_rec_id=...&pr_seq=uniform from Shopify itself,
    // so appending "?section_id=quick-view" produced a second "?" mid-URL
    // instead of a real query param. Shopify then had no section_id to
    // act on and returned the full product page instead of just the
    // quick-view section, which has no .qv-content — hence "this piece
    // could not be loaded" specifically on recommended items, never on
    // a plain product card. URL() handles both cases correctly.
    const quickViewUrl = new URL(productUrl, window.location.origin);
    quickViewUrl.searchParams.set('section_id', 'quick-view');

    fetch(quickViewUrl.toString())
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('.qv-content');

        if (!content) {
          this.body.innerHTML = '<div class="qv-error">Sorry, this piece could not be loaded.</div>';
          return;
        }

        this.body.innerHTML = content.outerHTML;

        const variantsData = this.body.querySelector('.qv-content')?.dataset.variants;
        if (variantsData) {
          try {
            window.productVariants = JSON.parse(variantsData);
          } catch (error) {
            /* ignore malformed variant data */
          }
        }
      })
      .catch(() => {
        this.body.innerHTML = '<div class="qv-error">Sorry, something went wrong.</div>';
      });
  }

  close() {
    this.removeAttribute('open');
  }

  swapImage(thumb) {
    const mainImage = this.body.querySelector('.qv-main-image');
    if (!mainImage) return;

    mainImage.src = thumb.dataset.full;
    mainImage.srcset = thumb.dataset.srcset;
    mainImage.alt = thumb.dataset.alt || '';

    this.body.querySelectorAll('[data-qv-thumb]').forEach((el) => el.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }
}

customElements.define('quick-view-modal', QuickViewModal);
